import { WindowTitle } from "@dashboard/components/WindowTitle";
import { useIntl } from "react-intl";

import { openingHoursMessages } from "./messages";
import { OpeningHours } from "./OpeningHours";

const OpeningHoursSection = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(openingHoursMessages.sectionName)} />
      <OpeningHours />
    </>
  );
};

export default OpeningHoursSection;
